// Cleans the scene image before the effects read it. One NaN or infinite pixel in the half-float
// buffer (a shader dividing by zero, a highlight past half-float range) is spread over the whole
// picture by the bloom's mip blur, and the frame comes out black: a one-frame flicker.
import { BlendFunction, Effect } from 'postprocessing';

/** Largest value kept: below half-float max (65504), with room for the bloom to add up. */
export const SANITIZE_MAX = 16384.0;

const fragment = /* glsl */ `
void mainImage(const in vec4 inputColor, const in vec2 uv, out vec4 outputColor) {
  vec3 c = inputColor.rgb;
  // NaN becomes black; if a fast-math driver compiles isnan away, min/max still return the
  // non-NaN operand on GPUs. Infinity and overbright values are clamped.
  if (any(isnan(c))) c = vec3(0.0);
  c = min(max(c, vec3(0.0)), vec3(${SANITIZE_MAX.toFixed(1)}));
  outputColor = vec4(c, inputColor.a);
}`;

export class SanitizeEffect extends Effect {
  constructor() {
    super('Sanitize', fragment, { blendFunction: BlendFunction.SRC });
  }
}
